import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { Row, Col, Spinner, ModalHeader, ModalBody, Button, Modal } from "reactstrap"
import { withRouter } from "react-router"
import { ToastContainer, toast, Slide } from "react-toastify"
import ModalSurveillanceEnseignant from "./ModalSurveillanceEnseignant"

const DataTableSurveillanceEnseignant = ({ semestre }) => {
  const [loading, setLoading] = useState(false)
  const [orders, setOrders] = useState([])
  const [modal, setModal] = useState(false)
  const [row, setRow] = useState("")
  const [detailExam, setDetailExam] = useState([])
  const [annee, setAnnee] = useState("");
  var anneeScolaire = JSON.parse(localStorage.getItem("anneeScolaire"))
  var annee_id = anneeScolaire.Annee.id
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDelete, setModalDelete] = useState(false)

  const loadDetailExam = async () => {
    const res = await  API.post("surveillance/list/enseignant", {
      enseignant_id: row.id,
      semestre_id: semestre,
      annee_id
    }).then(res => {
      setDetailExam(res.data.Surveillance)
    })
  };
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    sizePerPage: 50,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }

  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "name",
      text: "Enseignant",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "cin",
      text: "CIN",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "grade",
      text: "Grade",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "Consultation",
      isDummyField: true,
      text: "Consultation",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <i
            style={{ color: "green", cursor: "pointer" }}
            onClick={() => toggle(row)}
            className="fas fa-eye"
          ></i>
        </div>
      ),
    },
    {
      dataField: "Consultation",
      isDummyField: true,
      text: "Consultation",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <i
            style={{ color: "#ED6464", cursor: "pointer" }}
            onClick={() => toggleDelate(row)}
            className="fas fa-trash-alt"
          ></i>
        </div>
      ),
    },
  ]

  const toggle = row => {
    setModal(true)
    setRow(row)
    const res = API.post("surveillance/list/enseignant", {
      enseignant_id: row.id,
      semestre_id: semestre,
      annee_id
    }).then(res => {
      setDetailExam(res.data.Surveillance)
    })
  }
  const toggleDelate = row => {
    setModalDelete(!modalDelete)
    setRow(row)

  }
  const toggleDeleteSurv = async () => {
      const res =  API.post("surveillance/delete", {
      enseignant_id: row.id,
      semestre_id: semestre,
      annee_id
    }).then(res => {
      API.post("surveillance/list/enseignant", {
        enseignant_id: row.id,
        semestre_id: semestre,
        annee_id
      }).then(res => {
        setModalDelete(false)
        setDetailExam(res.data.Surveillance)
      })
      setLoading(true)
    })

  }

  const toggleClose = () => {
    setModal(false)
  }

  const { SearchBar } = Search

  useEffect(async () => {
    if (localStorage.getItem("anneeScolaire")) {
      var anneeScolaire = JSON.parse(localStorage.getItem("anneeScolaire"))
      var annee = anneeScolaire.Annee.annee_scolaire
    }
    setAnnee(annee)
    const res = await API.post("emploi/enseignant/list", {
      semestre_id: semestre,
    }).then(res => {
      setOrders(res.data.enseignants)
      setLoading(true)
    })
  }, [semestre])

  useEffect(() => {
    if (modalOpen) {
      loadDetailExam();
    }
  }, [modalOpen]);
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row className="mt-4">
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <div>
                      <div className="mb-3 row" style={{ display: "flex" }}>
                        <div className="col-md-6 mb-3 row">
                          <div className="col-md-8 search-box-etd">
                            <div
                              className="search-box me-2 mb-2 d-inline-block"
                              style={{ width: "100%" }}
                            >
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      noDataIndication={() => <NoDataIndication />}
                      striped={false}
                      bordered={false}
                      classes={"table align-middle table-nowrap"}
                      headerWrapperClasses={"table-light"}
                      hover
                      pagination={paginationFactory(pageOptions)}
                      {...toolkitProps.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              En cours ...{" "}
            </h4>
          </div>
        )}
      </div>
      <ModalSurveillanceEnseignant
        toggle={toggle}
        modal={modal}
        row={row}
        detailExam={detailExam}
        semestre={semestre}
        toggleClose={toggleClose}
        annee={annee}
        annee_id={annee_id}
        refresh={loadDetailExam}
      />
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modalDelete} toggle={toggleDelate} centered={true}>
        <ModalHeader
          style={{width: "100% !important", textAlign: "center !important"}}
          toggle={toggleDelate}
          tag="h4"
        >
          {"Suppression surveillance enseignant"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{display: "flex", justifyContent: "center"}}>
              <p>
                {"Voulez-vous supprimer cette surveillance enseignant ?"}

              </p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDeleteSurv}
                >
                  <i
                    style={{color: "white"}}
                    className="far fa-thumbs-up"
                  ></i>
                  {"Oui"}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleDelate}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{color: "white"}}
                    className="far fa-thumbs-down"
                  ></i>
                  {"Non"}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(DataTableSurveillanceEnseignant)
DataTableSurveillanceEnseignant.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
  semestre: PropTypes.any,
}
